"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptimalVehiclesFromAvailable = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const lodash_1 = require("lodash");
const doesVehicleHaveEnoughSpace = (requirements) => (vehicle) => legacy_enums_1.VehicleTypesCapacity[vehicle] >= requirements.passengers &&
    legacy_enums_1.VehicleTypesCarryOns[vehicle] >= requirements.carryOns &&
    legacy_enums_1.VehicleTypesSuitcases[vehicle] >= requirements.suitcases;
const deprioritizeSedanLite = (availableVehicles) => {
    return availableVehicles.includes(legacy_enums_1.VehicleType.SedanLite)
        ? [...availableVehicles.filter((v) => v !== legacy_enums_1.VehicleType.SedanLite), legacy_enums_1.VehicleType.SedanLite]
        : [...availableVehicles];
};
const shouldExcludeLuxurySedan = (vehicles) => {
    return ((vehicles.includes(legacy_enums_1.VehicleType.Sedan) || vehicles.includes(legacy_enums_1.VehicleType.SedanLite)) &&
        vehicles.includes(legacy_enums_1.VehicleType.LuxurySedan));
};
const skipLuxurySedanIfSedanAvailable = (vehicles) => {
    if (shouldExcludeLuxurySedan(vehicles)) {
        return vehicles.filter((v) => v !== legacy_enums_1.VehicleType.LuxurySedan);
    }
    return vehicles;
};
const findSmallestVehicle = (vehicles) => vehicles.sort((a, b) => legacy_enums_1.VehicleTypesCapacity[a] - legacy_enums_1.VehicleTypesCapacity[b]).at(0) ?? null;
const getSmallestAvailableVehicle = (availableVehicles, requirements) => (0, lodash_1.flow)([
    deprioritizeSedanLite,
    (vehicles) => vehicles.filter(doesVehicleHaveEnoughSpace(requirements)),
    skipLuxurySedanIfSedanAvailable,
    findSmallestVehicle,
])(availableVehicles);
const getLargestAvailableVehicle = (availableVehicles) => availableVehicles.sort((a, b) => legacy_enums_1.VehicleTypesCapacity[b] - legacy_enums_1.VehicleTypesCapacity[a]).at(0) ?? availableVehicles[0];
/**
 * The getOptimalVehiclesByPassengersAndLuggage function determines
 * the optimal set of vehicles required to accommodate a given number of
 * passengers, suitcases, and carry-ons from a list of available vehicle types.
 * It selects the smallest suitable vehicles first
 * and continues until all requirements are met.
 */
const getOptimalVehiclesFromAvailable = (args) => {
    const { passengers, suitcases, carryOns, availableVehicles } = args;
    if (!availableVehicles.length) {
        return [];
    }
    if (passengers === 0 && suitcases === 0 && carryOns === 0) {
        return [legacy_enums_1.VehicleType.Sedan];
    }
    const vehicles = [];
    let remainingPassengers = passengers;
    let remainingSuitcases = suitcases;
    let remainingCarryOns = carryOns;
    while (remainingPassengers > 0 || remainingSuitcases > 0 || remainingCarryOns > 0) {
        let vehicle = getSmallestAvailableVehicle(availableVehicles, {
            passengers: remainingPassengers,
            suitcases: remainingSuitcases,
            carryOns: remainingCarryOns,
        });
        if (vehicle === null) {
            vehicle = getLargestAvailableVehicle(availableVehicles);
        }
        vehicles.push(vehicle);
        remainingPassengers -= legacy_enums_1.VehicleTypesCapacity[vehicle];
        remainingSuitcases -= legacy_enums_1.VehicleTypesSuitcases[vehicle];
        remainingCarryOns -= legacy_enums_1.VehicleTypesCarryOns[vehicle];
    }
    return vehicles;
};
exports.getOptimalVehiclesFromAvailable = getOptimalVehiclesFromAvailable;
//# sourceMappingURL=getOptimalVehiclesFromAvailable.js.map